import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';

import Modal from './Modal';
import ProductDetails from './ProductDetails';
import RichText from '../components/RichText';
import {removeTrapFocus} from '../helpers/a11y';

export default class ProductQuickshop {
  constructor(options) {
    this.$el = options.$el;
    this.$quickShop = this.$el.find('[data-product-quickshop]');
    this.modalClass = options.modalClass;
    this.loaded = false;
    this.richText = null;
    this.productDetails = null;
    this.quickShopHTML = null;

    try {
      this.data = JSON.parse(this.$el.find('[data-product-quickshop-data]').text());
    } catch (error) {
      return console.warn(`Quickshop: invalid quickshop data found. ${error.message}`);
    }

    try {
      this.quickShopHTML = JSON.parse(this.$el.find('[data-product-quickshop-html]').text());
    } catch (error) {
      return console.warn(`Quickshop: invalid quickshop html found. ${error.message}`);
    }

    if (!this.$quickShop[0].hasAttribute('data-loaded')) {
      this.$quickShop.append(this.quickShopHTML);
      this.$quickShop.attr('data-loaded', true);
      this.$quickShop
        .find('.money')
        .each((index, el) => CurrencyConverter.update(el));
      this._initSPR();
    }

    this._initialize();

    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
  }

  _initSPR() {
    if (!window.SPR) {
      return;
    }

    window.SPR.registerCallbacks();
    window.SPR.initRatingHandler();
    window.SPR.initDomEls();
    window.SPR.loadProducts();
    window.SPR.loadBadges();
  }

  _initialize() {
    this.$message = this.$el.find('[data-product-quickshop-message]');
    this.$formArea = this.$el.find('[data-product-form-area]');
    this.$gallery = this.$el.find('[data-product-gallery]');
    this.$details = this.$el.find('[data-product-details]');
    this.$description = this.$el.find('[data-product-description]');
    this.context = this.data.context;
    this.settings = this.data.settings;
    this.product = this.data.product;

    this._open = this._open.bind(this);
    this._close = this._close.bind(this);

    this._onATCClose = this._onATCClose.bind(this);
    this._onATCInit = this._onATCInit.bind(this);
    this._onATCError = this._onATCError.bind(this);
    this._onATCSuccess = this._onATCSuccess.bind(this);

    const modalCallbacks = {
      onOpen: this._open,
      onClose: this._close,
    };

    this.atcCallbacks = {
      onClose: this._onATCClose,
      onInit: this._onATCInit,
      onError: this._onATCError,
      onSuccess: this._onATCSuccess,
    };

    this.modal = new Modal(modalCallbacks);
    this.modal.open(`[data-product-quickshop="${this.product.id}"]`, this.modalClass);
  }

  _open() {
    if (this.loaded) {
      return;
    }

    if (this.$description.length) {
      this.richText = new RichText(this.$description);
    }

    const options = {
      $formArea: this.$formArea,
      $gallery: this.$gallery,
      $details: this.$details,
      atcCallbacks: this.atcCallbacks,
      context: this.context,
      settings: this.settings,
      product: this.product,
      useHistory: false,
    };

    this.productDetails = new ProductDetails(options);
  }

  _close() {
    if (this.productDetails) {
      this.productDetails.unload();
    }

    if (this.richText) {
      this.richText.unload();
    }

    this._toggleMessage('', false);
    this.modal.unload();
  }

  _toggleMessage(message, isVisible) {
    this.$message
      .html(message)
      .toggleClass('visible', isVisible);
  }

  _onATCClose() {
    removeTrapFocus({
      namespace: 'product-details-flyout',
    });

    this.$el.focus();
  }

  _onATCInit() {
    this.$message.removeClass('visible');
  }

  _onATCError(error) {
    const $content = $(`<div class="product-message--error">${error}</div>`);
    this._toggleMessage($content, true);
  }

  _onATCSuccess() {
    this._close();
  }

  unload() {
    this._close();
  }
}
